import React from 'react'
import './Topbar.css'
import {BsPlus} from "react-icons/bs"

const Topbar = ({createnotice, forwardnotice, role}) => {
  const handleNotice = () =>{
    createnotice()
  }

  const handleforNotice = () =>{
    forwardnotice()
  }

  // console.log(role.role)

  return (
    <div className='topbar-container'>
        <span>Overview</span>
        {role.role !== 'STAFF' ? <div className='create-notice-container'>
            <BsPlus id='cnc-id-plus'/>
            {role.role === 'HR' ? <span onClick={handleNotice}>Create Notice</span> : <span onClick={handleforNotice}>Forward Notice</span> }

            {role.role === 'HR' ? <div className='btn-overlay-leaf' onClick={handleNotice}/> : <div className='btn-overlay-leaf' onClick={handleforNotice}/>}
        </div> : <></>}
    </div>
  )
}

export default Topbar